import DVCore, { BaseAPI } from "./core/DVCore";

const TicketsAPI = BaseAPI("/api/tickets/");

export default TicketsAPI;